/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as AdminRouteRouteImport } from "./routes/admin/route"
import { Route as CreateOrgRouteImport } from "./routes/create-org"
import { Route as DataDeletionRouteImport } from "./routes/data-deletion"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as OnboardingRouteImport } from "./routes/onboarding"
import { Route as PrivacyRouteImport } from "./routes/privacy"
import { Route as TermsRouteImport } from "./routes/terms"
import { Route as AppAnalyticsRouteImport } from "./routes/_app/analytics"
import { Route as AppApprovalsRouteImport } from "./routes/_app/approvals"
import { Route as AppAssistantRouteImport } from "./routes/_app/assistant"
import { Route as AppCalendarRouteImport } from "./routes/_app/calendar"
import { Route as AppComposeRouteImport } from "./routes/_app/compose"
import { Route as AppHomeRouteImport } from "./routes/_app/home"
import { Route as AppInboxRouteImport } from "./routes/_app/inbox"
import { Route as AppJobsRouteImport } from "./routes/_app/jobs"
import { Route as AppPostsRouteImport } from "./routes/_app/posts"
import { Route as AppRulesRouteImport } from "./routes/_app/rules"
import { Route as AppSettingsRouteRouteImport } from "./routes/_app/settings/route"
import { Route as AppStudioRouteImport } from "./routes/_app/studio"
import { Route as AdminIndexRouteImport } from "./routes/admin/index"
import { Route as AdminAiRouteImport } from "./routes/admin/ai"
import { Route as AdminAiActivityRouteImport } from "./routes/admin/ai-activity"
import { Route as AdminAuditRouteImport } from "./routes/admin/audit"
import { Route as AdminCalendarRouteImport } from "./routes/admin/calendar"
import { Route as AdminFlowsRouteImport } from "./routes/admin/flows"
import { Route as AdminOrgsRouteImport } from "./routes/admin/orgs"
import { Route as AdminPlanLogRouteImport } from "./routes/admin/plan-log"
import { Route as AdminPlansRouteImport } from "./routes/admin/plans"
import { Route as AdminRequestsRouteImport } from "./routes/admin/requests"
import { Route as AdminSettingsRouteImport } from "./routes/admin/settings"
import { Route as AdminSystemRouteImport } from "./routes/admin/system"
import { Route as AdminUsersRouteImport } from "./routes/admin/users"
import { Route as SignupIndexRouteImport } from "./routes/signup/index"
import { Route as SignupReceivedRouteImport } from "./routes/signup/received"
import { Route as AppAutomationIndexRouteImport } from "./routes/_app/automation/index"
import { Route as AppAutomationLogRouteImport } from "./routes/_app/automation/log"
import { Route as AppAutomationRunsRouteImport } from "./routes/_app/automation/runs"
import { Route as AppContactsIndexRouteImport } from "./routes/_app/contacts/index"
import { Route as AppContactsContactIdRouteImport } from "./routes/_app/contacts/$contactId"
import { Route as AppContentIndexRouteImport } from "./routes/_app/content/index"
import { Route as AppContentComposeRouteImport } from "./routes/_app/content/compose"
import { Route as AppDashboardsIndexRouteImport } from "./routes/_app/dashboards/index"
import { Route as AppDashboardsDashboardIdRouteImport } from "./routes/_app/dashboards/$dashboardId"
import { Route as AppPeopleIndexRouteImport } from "./routes/_app/people/index"
import { Route as AppPeopleContactIdRouteImport } from "./routes/_app/people/$contactId"
import { Route as AppSettingsIndexRouteImport } from "./routes/_app/settings/index"
import { Route as AppSettingsAiRouteImport } from "./routes/_app/settings/ai"
import { Route as AppSettingsApiRouteImport } from "./routes/_app/settings/api"
import { Route as AppSettingsAppearanceRouteImport } from "./routes/_app/settings/appearance"
import { Route as AppSettingsBillingRouteImport } from "./routes/_app/settings/billing"
import { Route as AppSettingsCalendarRouteImport } from "./routes/_app/settings/calendar"
import { Route as AppSettingsChannelsRouteImport } from "./routes/_app/settings/channels"
import { Route as AppSettingsDataRouteImport } from "./routes/_app/settings/data"
import { Route as AppSettingsGeneralRouteImport } from "./routes/_app/settings/general"
import { Route as AppSettingsNotificationsRouteImport } from "./routes/_app/settings/notifications"
import { Route as AppSettingsPlanRouteImport } from "./routes/_app/settings/plan"
import { Route as AppSettingsPreferencesRouteImport } from "./routes/_app/settings/preferences"
import { Route as AppSettingsProfileRouteImport } from "./routes/_app/settings/profile"
import { Route as AppSettingsTagsRouteImport } from "./routes/_app/settings/tags"
import { Route as AppSettingsTeamRouteImport } from "./routes/_app/settings/team"
import { Route as AdminOrgPlanOrgIdRouteImport } from "./routes/admin/org-plan.$orgId"
import { Route as AppAutomationAgentsIndexRouteImport } from "./routes/_app/automation/agents/index"
import { Route as AppAutomationAgentsAgentIdRouteImport } from "./routes/_app/automation/agents/$agentId"
import { Route as AppAutomationRulesRuleIdRouteImport } from "./routes/_app/automation/rules/$ruleId"
import { Route as AppContentPostsIndexRouteImport } from "./routes/_app/content/posts/index"
import { Route as AppContentPostsPostIdRouteImport } from "./routes/_app/content/posts/$postId"
import { Route as AppDashboardsAccountAccountIdRouteImport } from "./routes/_app/dashboards/account/$accountId"
import { Route as AdminOrgsOrgIdAiRouteImport } from "./routes/admin/orgs_.$orgId.ai"
import { Route as AdminUsersUserIdAiRouteImport } from "./routes/admin/users_.$userId.ai"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any)
const CreateOrgRoute = CreateOrgRouteImport.update({
  id: "/create-org",
  path: "/create-org",
  getParentRoute: () => rootRouteImport,
} as any)
const DataDeletionRoute = DataDeletionRouteImport.update({
  id: "/data-deletion",
  path: "/data-deletion",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: "/terms",
  path: "/terms",
  getParentRoute: () => rootRouteImport,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: "/analytics",
  path: "/analytics",
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRoute = AppApprovalsRouteImport.update({
  id: "/approvals",
  path: "/approvals",
  getParentRoute: () => AppRoute,
} as any)
const AppAssistantRoute = AppAssistantRouteImport.update({
  id: "/assistant",
  path: "/assistant",
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: "/calendar",
  path: "/calendar",
  getParentRoute: () => AppRoute,
} as any)
const AppComposeRoute = AppComposeRouteImport.update({
  id: "/compose",
  path: "/compose",
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: "/home",
  path: "/home",
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: "/inbox",
  path: "/inbox",
  getParentRoute: () => AppRoute,
} as any)
const AppJobsRoute = AppJobsRouteImport.update({
  id: "/jobs",
  path: "/jobs",
  getParentRoute: () => AppRoute,
} as any)
const AppPostsRoute = AppPostsRouteImport.update({
  id: "/posts",
  path: "/posts",
  getParentRoute: () => AppRoute,
} as any)
const AppRulesRoute = AppRulesRouteImport.update({
  id: "/rules",
  path: "/rules",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any)
const AppStudioRoute = AppStudioRouteImport.update({
  id: "/studio",
  path: "/studio",
  getParentRoute: () => AppRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAiRoute = AdminAiRouteImport.update({
  id: "/ai",
  path: "/ai",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAiActivityRoute = AdminAiActivityRouteImport.update({
  id: "/ai-activity",
  path: "/ai-activity",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCalendarRoute = AdminCalendarRouteImport.update({
  id: "/calendar",
  path: "/calendar",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFlowsRoute = AdminFlowsRouteImport.update({
  id: "/flows",
  path: "/flows",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOrgsRoute = AdminOrgsRouteImport.update({
  id: "/orgs",
  path: "/orgs",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPlanLogRoute = AdminPlanLogRouteImport.update({
  id: "/plan-log",
  path: "/plan-log",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPlansRoute = AdminPlansRouteImport.update({
  id: "/plans",
  path: "/plans",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRequestsRoute = AdminRequestsRouteImport.update({
  id: "/requests",
  path: "/requests",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSystemRoute = AdminSystemRouteImport.update({
  id: "/system",
  path: "/system",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: "/users",
  path: "/users",
  getParentRoute: () => AdminRouteRoute,
} as any)
const SignupIndexRoute = SignupIndexRouteImport.update({
  id: "/signup/",
  path: "/signup/",
  getParentRoute: () => rootRouteImport,
} as any)
const SignupReceivedRoute = SignupReceivedRouteImport.update({
  id: "/signup/received",
  path: "/signup/received",
  getParentRoute: () => rootRouteImport,
} as any)
const AppAutomationIndexRoute = AppAutomationIndexRouteImport.update({
  id: "/automation/",
  path: "/automation/",
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationLogRoute = AppAutomationLogRouteImport.update({
  id: "/automation/log",
  path: "/automation/log",
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationRunsRoute = AppAutomationRunsRouteImport.update({
  id: "/automation/runs",
  path: "/automation/runs",
  getParentRoute: () => AppRoute,
} as any)
const AppContactsIndexRoute = AppContactsIndexRouteImport.update({
  id: "/contacts/",
  path: "/contacts/",
  getParentRoute: () => AppRoute,
} as any)
const AppContactsContactIdRoute = AppContactsContactIdRouteImport.update({
  id: "/contacts/$contactId",
  path: "/contacts/$contactId",
  getParentRoute: () => AppRoute,
} as any)
const AppContentIndexRoute = AppContentIndexRouteImport.update({
  id: "/content/",
  path: "/content/",
  getParentRoute: () => AppRoute,
} as any)
const AppContentComposeRoute = AppContentComposeRouteImport.update({
  id: "/content/compose",
  path: "/content/compose",
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsIndexRoute = AppDashboardsIndexRouteImport.update({
  id: "/dashboards/",
  path: "/dashboards/",
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsDashboardIdRoute =
  AppDashboardsDashboardIdRouteImport.update({
    id: "/dashboards/$dashboardId",
    path: "/dashboards/$dashboardId",
    getParentRoute: () => AppRoute,
  } as any)
const AppPeopleIndexRoute = AppPeopleIndexRouteImport.update({
  id: "/people/",
  path: "/people/",
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleContactIdRoute = AppPeopleContactIdRouteImport.update({
  id: "/people/$contactId",
  path: "/people/$contactId",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAiRoute = AppSettingsAiRouteImport.update({
  id: "/ai",
  path: "/ai",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsApiRoute = AppSettingsApiRouteImport.update({
  id: "/api",
  path: "/api",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAppearanceRoute = AppSettingsAppearanceRouteImport.update({
  id: "/appearance",
  path: "/appearance",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCalendarRoute = AppSettingsCalendarRouteImport.update({
  id: "/calendar",
  path: "/calendar",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsChannelsRoute = AppSettingsChannelsRouteImport.update({
  id: "/channels",
  path: "/channels",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDataRoute = AppSettingsDataRouteImport.update({
  id: "/data",
  path: "/data",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsGeneralRoute = AppSettingsGeneralRouteImport.update({
  id: "/general",
  path: "/general",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsPlanRoute = AppSettingsPlanRouteImport.update({
  id: "/plan",
  path: "/plan",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPreferencesRoute = AppSettingsPreferencesRouteImport.update({
  id: "/preferences",
  path: "/preferences",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTagsRoute = AppSettingsTagsRouteImport.update({
  id: "/tags",
  path: "/tags",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
  id: "/team",
  path: "/team",
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AdminOrgPlanOrgIdRoute = AdminOrgPlanOrgIdRouteImport.update({
  id: "/org-plan/$orgId",
  path: "/org-plan/$orgId",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppAutomationAgentsIndexRoute =
  AppAutomationAgentsIndexRouteImport.update({
    id: "/automation/agents/",
    path: "/automation/agents/",
    getParentRoute: () => AppRoute,
  } as any)
const AppAutomationAgentsAgentIdRoute =
  AppAutomationAgentsAgentIdRouteImport.update({
    id: "/automation/agents/$agentId",
    path: "/automation/agents/$agentId",
    getParentRoute: () => AppRoute,
  } as any)
const AppAutomationRulesRuleIdRoute =
  AppAutomationRulesRuleIdRouteImport.update({
    id: "/automation/rules/$ruleId",
    path: "/automation/rules/$ruleId",
    getParentRoute: () => AppRoute,
  } as any)
const AppContentPostsIndexRoute = AppContentPostsIndexRouteImport.update({
  id: "/content/posts/",
  path: "/content/posts/",
  getParentRoute: () => AppRoute,
} as any)
const AppContentPostsPostIdRoute = AppContentPostsPostIdRouteImport.update({
  id: "/content/posts/$postId",
  path: "/content/posts/$postId",
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsAccountAccountIdRoute =
  AppDashboardsAccountAccountIdRouteImport.update({
    id: "/dashboards/account/$accountId",
    path: "/dashboards/account/$accountId",
    getParentRoute: () => AppRoute,
  } as any)
const AdminOrgsOrgIdAiRoute = AdminOrgsOrgIdAiRouteImport.update({
  id: "/orgs_/$orgId/ai",
  path: "/orgs/$orgId/ai",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersUserIdAiRoute = AdminUsersUserIdAiRouteImport.update({
  id: "/users_/$userId/ai",
  path: "/users/$userId/ai",
  getParentRoute: () => AdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/admin": typeof AdminRouteRouteWithChildren
  "/create-org": typeof CreateOrgRoute
  "/data-deletion": typeof DataDeletionRoute
  "/login": typeof LoginRoute
  "/onboarding": typeof OnboardingRoute
  "/privacy": typeof PrivacyRoute
  "/terms": typeof TermsRoute
  "/settings": typeof AppSettingsRouteRouteWithChildren
  "/analytics": typeof AppAnalyticsRoute
  "/approvals": typeof AppApprovalsRoute
  "/assistant": typeof AppAssistantRoute
  "/calendar": typeof AppCalendarRoute
  "/compose": typeof AppComposeRoute
  "/home": typeof AppHomeRoute
  "/inbox": typeof AppInboxRoute
  "/jobs": typeof AppJobsRoute
  "/posts": typeof AppPostsRoute
  "/rules": typeof AppRulesRoute
  "/studio": typeof AppStudioRoute
  "/admin/ai": typeof AdminAiRoute
  "/admin/ai-activity": typeof AdminAiActivityRoute
  "/admin/audit": typeof AdminAuditRoute
  "/admin/calendar": typeof AdminCalendarRoute
  "/admin/flows": typeof AdminFlowsRoute
  "/admin/orgs": typeof AdminOrgsRoute
  "/admin/plan-log": typeof AdminPlanLogRoute
  "/admin/plans": typeof AdminPlansRoute
  "/admin/requests": typeof AdminRequestsRoute
  "/admin/settings": typeof AdminSettingsRoute
  "/admin/system": typeof AdminSystemRoute
  "/admin/users": typeof AdminUsersRoute
  "/signup/received": typeof SignupReceivedRoute
  "/admin/": typeof AdminIndexRoute
  "/signup/": typeof SignupIndexRoute
  "/automation/log": typeof AppAutomationLogRoute
  "/automation/runs": typeof AppAutomationRunsRoute
  "/contacts/$contactId": typeof AppContactsContactIdRoute
  "/content/compose": typeof AppContentComposeRoute
  "/dashboards/$dashboardId": typeof AppDashboardsDashboardIdRoute
  "/people/$contactId": typeof AppPeopleContactIdRoute
  "/settings/ai": typeof AppSettingsAiRoute
  "/settings/api": typeof AppSettingsApiRoute
  "/settings/appearance": typeof AppSettingsAppearanceRoute
  "/settings/billing": typeof AppSettingsBillingRoute
  "/settings/calendar": typeof AppSettingsCalendarRoute
  "/settings/channels": typeof AppSettingsChannelsRoute
  "/settings/data": typeof AppSettingsDataRoute
  "/settings/general": typeof AppSettingsGeneralRoute
  "/settings/notifications": typeof AppSettingsNotificationsRoute
  "/settings/plan": typeof AppSettingsPlanRoute
  "/settings/preferences": typeof AppSettingsPreferencesRoute
  "/settings/profile": typeof AppSettingsProfileRoute
  "/settings/tags": typeof AppSettingsTagsRoute
  "/settings/team": typeof AppSettingsTeamRoute
  "/admin/org-plan/$orgId": typeof AdminOrgPlanOrgIdRoute
  "/automation/": typeof AppAutomationIndexRoute
  "/contacts/": typeof AppContactsIndexRoute
  "/content/": typeof AppContentIndexRoute
  "/dashboards/": typeof AppDashboardsIndexRoute
  "/people/": typeof AppPeopleIndexRoute
  "/settings/": typeof AppSettingsIndexRoute
  "/automation/agents/$agentId": typeof AppAutomationAgentsAgentIdRoute
  "/automation/rules/$ruleId": typeof AppAutomationRulesRuleIdRoute
  "/content/posts/$postId": typeof AppContentPostsPostIdRoute
  "/dashboards/account/$accountId": typeof AppDashboardsAccountAccountIdRoute
  "/admin/orgs/$orgId/ai": typeof AdminOrgsOrgIdAiRoute
  "/admin/users/$userId/ai": typeof AdminUsersUserIdAiRoute
  "/automation/agents/": typeof AppAutomationAgentsIndexRoute
  "/content/posts/": typeof AppContentPostsIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/create-org": typeof CreateOrgRoute
  "/data-deletion": typeof DataDeletionRoute
  "/login": typeof LoginRoute
  "/onboarding": typeof OnboardingRoute
  "/privacy": typeof PrivacyRoute
  "/terms": typeof TermsRoute
  "/analytics": typeof AppAnalyticsRoute
  "/approvals": typeof AppApprovalsRoute
  "/assistant": typeof AppAssistantRoute
  "/calendar": typeof AppCalendarRoute
  "/compose": typeof AppComposeRoute
  "/home": typeof AppHomeRoute
  "/inbox": typeof AppInboxRoute
  "/jobs": typeof AppJobsRoute
  "/posts": typeof AppPostsRoute
  "/rules": typeof AppRulesRoute
  "/studio": typeof AppStudioRoute
  "/admin/ai": typeof AdminAiRoute
  "/admin/ai-activity": typeof AdminAiActivityRoute
  "/admin/audit": typeof AdminAuditRoute
  "/admin/calendar": typeof AdminCalendarRoute
  "/admin/flows": typeof AdminFlowsRoute
  "/admin/orgs": typeof AdminOrgsRoute
  "/admin/plan-log": typeof AdminPlanLogRoute
  "/admin/plans": typeof AdminPlansRoute
  "/admin/requests": typeof AdminRequestsRoute
  "/admin/settings": typeof AdminSettingsRoute
  "/admin/system": typeof AdminSystemRoute
  "/admin/users": typeof AdminUsersRoute
  "/signup/received": typeof SignupReceivedRoute
  "/admin": typeof AdminIndexRoute
  "/signup": typeof SignupIndexRoute
  "/automation/log": typeof AppAutomationLogRoute
  "/automation/runs": typeof AppAutomationRunsRoute
  "/contacts/$contactId": typeof AppContactsContactIdRoute
  "/content/compose": typeof AppContentComposeRoute
  "/dashboards/$dashboardId": typeof AppDashboardsDashboardIdRoute
  "/people/$contactId": typeof AppPeopleContactIdRoute
  "/settings/ai": typeof AppSettingsAiRoute
  "/settings/api": typeof AppSettingsApiRoute
  "/settings/appearance": typeof AppSettingsAppearanceRoute
  "/settings/billing": typeof AppSettingsBillingRoute
  "/settings/calendar": typeof AppSettingsCalendarRoute
  "/settings/channels": typeof AppSettingsChannelsRoute
  "/settings/data": typeof AppSettingsDataRoute
  "/settings/general": typeof AppSettingsGeneralRoute
  "/settings/notifications": typeof AppSettingsNotificationsRoute
  "/settings/plan": typeof AppSettingsPlanRoute
  "/settings/preferences": typeof AppSettingsPreferencesRoute
  "/settings/profile": typeof AppSettingsProfileRoute
  "/settings/tags": typeof AppSettingsTagsRoute
  "/settings/team": typeof AppSettingsTeamRoute
  "/admin/org-plan/$orgId": typeof AdminOrgPlanOrgIdRoute
  "/automation": typeof AppAutomationIndexRoute
  "/contacts": typeof AppContactsIndexRoute
  "/content": typeof AppContentIndexRoute
  "/dashboards": typeof AppDashboardsIndexRoute
  "/people": typeof AppPeopleIndexRoute
  "/settings": typeof AppSettingsIndexRoute
  "/automation/agents/$agentId": typeof AppAutomationAgentsAgentIdRoute
  "/automation/rules/$ruleId": typeof AppAutomationRulesRuleIdRoute
  "/content/posts/$postId": typeof AppContentPostsPostIdRoute
  "/dashboards/account/$accountId": typeof AppDashboardsAccountAccountIdRoute
  "/admin/orgs/$orgId/ai": typeof AdminOrgsOrgIdAiRoute
  "/admin/users/$userId/ai": typeof AdminUsersUserIdAiRoute
  "/automation/agents": typeof AppAutomationAgentsIndexRoute
  "/content/posts": typeof AppContentPostsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/admin": typeof AdminRouteRouteWithChildren
  "/_app": typeof AppRouteWithChildren
  "/create-org": typeof CreateOrgRoute
  "/data-deletion": typeof DataDeletionRoute
  "/login": typeof LoginRoute
  "/onboarding": typeof OnboardingRoute
  "/privacy": typeof PrivacyRoute
  "/terms": typeof TermsRoute
  "/_app/settings": typeof AppSettingsRouteRouteWithChildren
  "/_app/analytics": typeof AppAnalyticsRoute
  "/_app/approvals": typeof AppApprovalsRoute
  "/_app/assistant": typeof AppAssistantRoute
  "/_app/calendar": typeof AppCalendarRoute
  "/_app/compose": typeof AppComposeRoute
  "/_app/home": typeof AppHomeRoute
  "/_app/inbox": typeof AppInboxRoute
  "/_app/jobs": typeof AppJobsRoute
  "/_app/posts": typeof AppPostsRoute
  "/_app/rules": typeof AppRulesRoute
  "/_app/studio": typeof AppStudioRoute
  "/admin/ai": typeof AdminAiRoute
  "/admin/ai-activity": typeof AdminAiActivityRoute
  "/admin/audit": typeof AdminAuditRoute
  "/admin/calendar": typeof AdminCalendarRoute
  "/admin/flows": typeof AdminFlowsRoute
  "/admin/orgs": typeof AdminOrgsRoute
  "/admin/plan-log": typeof AdminPlanLogRoute
  "/admin/plans": typeof AdminPlansRoute
  "/admin/requests": typeof AdminRequestsRoute
  "/admin/settings": typeof AdminSettingsRoute
  "/admin/system": typeof AdminSystemRoute
  "/admin/users": typeof AdminUsersRoute
  "/signup/received": typeof SignupReceivedRoute
  "/admin/": typeof AdminIndexRoute
  "/signup/": typeof SignupIndexRoute
  "/_app/automation/log": typeof AppAutomationLogRoute
  "/_app/automation/runs": typeof AppAutomationRunsRoute
  "/_app/contacts/$contactId": typeof AppContactsContactIdRoute
  "/_app/content/compose": typeof AppContentComposeRoute
  "/_app/dashboards/$dashboardId": typeof AppDashboardsDashboardIdRoute
  "/_app/people/$contactId": typeof AppPeopleContactIdRoute
  "/_app/settings/ai": typeof AppSettingsAiRoute
  "/_app/settings/api": typeof AppSettingsApiRoute
  "/_app/settings/appearance": typeof AppSettingsAppearanceRoute
  "/_app/settings/billing": typeof AppSettingsBillingRoute
  "/_app/settings/calendar": typeof AppSettingsCalendarRoute
  "/_app/settings/channels": typeof AppSettingsChannelsRoute
  "/_app/settings/data": typeof AppSettingsDataRoute
  "/_app/settings/general": typeof AppSettingsGeneralRoute
  "/_app/settings/notifications": typeof AppSettingsNotificationsRoute
  "/_app/settings/plan": typeof AppSettingsPlanRoute
  "/_app/settings/preferences": typeof AppSettingsPreferencesRoute
  "/_app/settings/profile": typeof AppSettingsProfileRoute
  "/_app/settings/tags": typeof AppSettingsTagsRoute
  "/_app/settings/team": typeof AppSettingsTeamRoute
  "/admin/org-plan/$orgId": typeof AdminOrgPlanOrgIdRoute
  "/_app/automation/": typeof AppAutomationIndexRoute
  "/_app/contacts/": typeof AppContactsIndexRoute
  "/_app/content/": typeof AppContentIndexRoute
  "/_app/dashboards/": typeof AppDashboardsIndexRoute
  "/_app/people/": typeof AppPeopleIndexRoute
  "/_app/settings/": typeof AppSettingsIndexRoute
  "/_app/automation/agents/$agentId": typeof AppAutomationAgentsAgentIdRoute
  "/_app/automation/rules/$ruleId": typeof AppAutomationRulesRuleIdRoute
  "/_app/content/posts/$postId": typeof AppContentPostsPostIdRoute
  "/_app/dashboards/account/$accountId": typeof AppDashboardsAccountAccountIdRoute
  "/admin/orgs_/$orgId/ai": typeof AdminOrgsOrgIdAiRoute
  "/admin/users_/$userId/ai": typeof AdminUsersUserIdAiRoute
  "/_app/automation/agents/": typeof AppAutomationAgentsIndexRoute
  "/_app/content/posts/": typeof AppContentPostsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/admin"
    | "/create-org"
    | "/data-deletion"
    | "/login"
    | "/onboarding"
    | "/privacy"
    | "/terms"
    | "/settings"
    | "/analytics"
    | "/approvals"
    | "/assistant"
    | "/calendar"
    | "/compose"
    | "/home"
    | "/inbox"
    | "/jobs"
    | "/posts"
    | "/rules"
    | "/studio"
    | "/admin/ai"
    | "/admin/ai-activity"
    | "/admin/audit"
    | "/admin/calendar"
    | "/admin/flows"
    | "/admin/orgs"
    | "/admin/plan-log"
    | "/admin/plans"
    | "/admin/requests"
    | "/admin/settings"
    | "/admin/system"
    | "/admin/users"
    | "/signup/received"
    | "/admin/"
    | "/signup/"
    | "/automation/log"
    | "/automation/runs"
    | "/contacts/$contactId"
    | "/content/compose"
    | "/dashboards/$dashboardId"
    | "/people/$contactId"
    | "/settings/ai"
    | "/settings/api"
    | "/settings/appearance"
    | "/settings/billing"
    | "/settings/calendar"
    | "/settings/channels"
    | "/settings/data"
    | "/settings/general"
    | "/settings/notifications"
    | "/settings/plan"
    | "/settings/preferences"
    | "/settings/profile"
    | "/settings/tags"
    | "/settings/team"
    | "/admin/org-plan/$orgId"
    | "/automation/"
    | "/contacts/"
    | "/content/"
    | "/dashboards/"
    | "/people/"
    | "/settings/"
    | "/automation/agents/$agentId"
    | "/automation/rules/$ruleId"
    | "/content/posts/$postId"
    | "/dashboards/account/$accountId"
    | "/admin/orgs/$orgId/ai"
    | "/admin/users/$userId/ai"
    | "/automation/agents/"
    | "/content/posts/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/create-org"
    | "/data-deletion"
    | "/login"
    | "/onboarding"
    | "/privacy"
    | "/terms"
    | "/analytics"
    | "/approvals"
    | "/assistant"
    | "/calendar"
    | "/compose"
    | "/home"
    | "/inbox"
    | "/jobs"
    | "/posts"
    | "/rules"
    | "/studio"
    | "/admin/ai"
    | "/admin/ai-activity"
    | "/admin/audit"
    | "/admin/calendar"
    | "/admin/flows"
    | "/admin/orgs"
    | "/admin/plan-log"
    | "/admin/plans"
    | "/admin/requests"
    | "/admin/settings"
    | "/admin/system"
    | "/admin/users"
    | "/signup/received"
    | "/admin"
    | "/signup"
    | "/automation/log"
    | "/automation/runs"
    | "/contacts/$contactId"
    | "/content/compose"
    | "/dashboards/$dashboardId"
    | "/people/$contactId"
    | "/settings/ai"
    | "/settings/api"
    | "/settings/appearance"
    | "/settings/billing"
    | "/settings/calendar"
    | "/settings/channels"
    | "/settings/data"
    | "/settings/general"
    | "/settings/notifications"
    | "/settings/plan"
    | "/settings/preferences"
    | "/settings/profile"
    | "/settings/tags"
    | "/settings/team"
    | "/admin/org-plan/$orgId"
    | "/automation"
    | "/contacts"
    | "/content"
    | "/dashboards"
    | "/people"
    | "/settings"
    | "/automation/agents/$agentId"
    | "/automation/rules/$ruleId"
    | "/content/posts/$postId"
    | "/dashboards/account/$accountId"
    | "/admin/orgs/$orgId/ai"
    | "/admin/users/$userId/ai"
    | "/automation/agents"
    | "/content/posts"
  id:
    | "__root__"
    | "/"
    | "/admin"
    | "/_app"
    | "/create-org"
    | "/data-deletion"
    | "/login"
    | "/onboarding"
    | "/privacy"
    | "/terms"
    | "/_app/settings"
    | "/_app/analytics"
    | "/_app/approvals"
    | "/_app/assistant"
    | "/_app/calendar"
    | "/_app/compose"
    | "/_app/home"
    | "/_app/inbox"
    | "/_app/jobs"
    | "/_app/posts"
    | "/_app/rules"
    | "/_app/studio"
    | "/admin/ai"
    | "/admin/ai-activity"
    | "/admin/audit"
    | "/admin/calendar"
    | "/admin/flows"
    | "/admin/orgs"
    | "/admin/plan-log"
    | "/admin/plans"
    | "/admin/requests"
    | "/admin/settings"
    | "/admin/system"
    | "/admin/users"
    | "/signup/received"
    | "/admin/"
    | "/signup/"
    | "/_app/automation/log"
    | "/_app/automation/runs"
    | "/_app/contacts/$contactId"
    | "/_app/content/compose"
    | "/_app/dashboards/$dashboardId"
    | "/_app/people/$contactId"
    | "/_app/settings/ai"
    | "/_app/settings/api"
    | "/_app/settings/appearance"
    | "/_app/settings/billing"
    | "/_app/settings/calendar"
    | "/_app/settings/channels"
    | "/_app/settings/data"
    | "/_app/settings/general"
    | "/_app/settings/notifications"
    | "/_app/settings/plan"
    | "/_app/settings/preferences"
    | "/_app/settings/profile"
    | "/_app/settings/tags"
    | "/_app/settings/team"
    | "/admin/org-plan/$orgId"
    | "/_app/automation/"
    | "/_app/contacts/"
    | "/_app/content/"
    | "/_app/dashboards/"
    | "/_app/people/"
    | "/_app/settings/"
    | "/_app/automation/agents/$agentId"
    | "/_app/automation/rules/$ruleId"
    | "/_app/content/posts/$postId"
    | "/_app/dashboards/account/$accountId"
    | "/admin/orgs_/$orgId/ai"
    | "/admin/users_/$userId/ai"
    | "/_app/automation/agents/"
    | "/_app/content/posts/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  CreateOrgRoute: typeof CreateOrgRoute
  DataDeletionRoute: typeof DataDeletionRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  SignupReceivedRoute: typeof SignupReceivedRoute
  SignupIndexRoute: typeof SignupIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin": {
      id: "/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/create-org": {
      id: "/create-org"
      path: "/create-org"
      fullPath: "/create-org"
      preLoaderRoute: typeof CreateOrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/data-deletion": {
      id: "/data-deletion"
      path: "/data-deletion"
      fullPath: "/data-deletion"
      preLoaderRoute: typeof DataDeletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/onboarding": {
      id: "/onboarding"
      path: "/onboarding"
      fullPath: "/onboarding"
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/privacy": {
      id: "/privacy"
      path: "/privacy"
      fullPath: "/privacy"
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/terms": {
      id: "/terms"
      path: "/terms"
      fullPath: "/terms"
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/analytics": {
      id: "/_app/analytics"
      path: "/analytics"
      fullPath: "/analytics"
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/approvals": {
      id: "/_app/approvals"
      path: "/approvals"
      fullPath: "/approvals"
      preLoaderRoute: typeof AppApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/assistant": {
      id: "/_app/assistant"
      path: "/assistant"
      fullPath: "/assistant"
      preLoaderRoute: typeof AppAssistantRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/calendar": {
      id: "/_app/calendar"
      path: "/calendar"
      fullPath: "/calendar"
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/compose": {
      id: "/_app/compose"
      path: "/compose"
      fullPath: "/compose"
      preLoaderRoute: typeof AppComposeRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/home": {
      id: "/_app/home"
      path: "/home"
      fullPath: "/home"
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/inbox": {
      id: "/_app/inbox"
      path: "/inbox"
      fullPath: "/inbox"
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/jobs": {
      id: "/_app/jobs"
      path: "/jobs"
      fullPath: "/jobs"
      preLoaderRoute: typeof AppJobsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/posts": {
      id: "/_app/posts"
      path: "/posts"
      fullPath: "/posts"
      preLoaderRoute: typeof AppPostsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/rules": {
      id: "/_app/rules"
      path: "/rules"
      fullPath: "/rules"
      preLoaderRoute: typeof AppRulesRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings": {
      id: "/_app/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/studio": {
      id: "/_app/studio"
      path: "/studio"
      fullPath: "/studio"
      preLoaderRoute: typeof AppStudioRouteImport
      parentRoute: typeof AppRoute
    }
    "/admin/": {
      id: "/admin/"
      path: "/"
      fullPath: "/admin/"
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/ai": {
      id: "/admin/ai"
      path: "/ai"
      fullPath: "/admin/ai"
      preLoaderRoute: typeof AdminAiRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/ai-activity": {
      id: "/admin/ai-activity"
      path: "/ai-activity"
      fullPath: "/admin/ai-activity"
      preLoaderRoute: typeof AdminAiActivityRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/audit": {
      id: "/admin/audit"
      path: "/audit"
      fullPath: "/admin/audit"
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/calendar": {
      id: "/admin/calendar"
      path: "/calendar"
      fullPath: "/admin/calendar"
      preLoaderRoute: typeof AdminCalendarRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/flows": {
      id: "/admin/flows"
      path: "/flows"
      fullPath: "/admin/flows"
      preLoaderRoute: typeof AdminFlowsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/orgs": {
      id: "/admin/orgs"
      path: "/orgs"
      fullPath: "/admin/orgs"
      preLoaderRoute: typeof AdminOrgsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/plan-log": {
      id: "/admin/plan-log"
      path: "/plan-log"
      fullPath: "/admin/plan-log"
      preLoaderRoute: typeof AdminPlanLogRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/plans": {
      id: "/admin/plans"
      path: "/plans"
      fullPath: "/admin/plans"
      preLoaderRoute: typeof AdminPlansRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/requests": {
      id: "/admin/requests"
      path: "/requests"
      fullPath: "/admin/requests"
      preLoaderRoute: typeof AdminRequestsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/settings": {
      id: "/admin/settings"
      path: "/settings"
      fullPath: "/admin/settings"
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/system": {
      id: "/admin/system"
      path: "/system"
      fullPath: "/admin/system"
      preLoaderRoute: typeof AdminSystemRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/users": {
      id: "/admin/users"
      path: "/users"
      fullPath: "/admin/users"
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/signup/": {
      id: "/signup/"
      path: "/signup"
      fullPath: "/signup/"
      preLoaderRoute: typeof SignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/signup/received": {
      id: "/signup/received"
      path: "/signup/received"
      fullPath: "/signup/received"
      preLoaderRoute: typeof SignupReceivedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/automation/": {
      id: "/_app/automation/"
      path: "/automation"
      fullPath: "/automation/"
      preLoaderRoute: typeof AppAutomationIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/automation/log": {
      id: "/_app/automation/log"
      path: "/automation/log"
      fullPath: "/automation/log"
      preLoaderRoute: typeof AppAutomationLogRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/automation/runs": {
      id: "/_app/automation/runs"
      path: "/automation/runs"
      fullPath: "/automation/runs"
      preLoaderRoute: typeof AppAutomationRunsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/contacts/": {
      id: "/_app/contacts/"
      path: "/contacts"
      fullPath: "/contacts/"
      preLoaderRoute: typeof AppContactsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/contacts/$contactId": {
      id: "/_app/contacts/$contactId"
      path: "/contacts/$contactId"
      fullPath: "/contacts/$contactId"
      preLoaderRoute: typeof AppContactsContactIdRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/content/": {
      id: "/_app/content/"
      path: "/content"
      fullPath: "/content/"
      preLoaderRoute: typeof AppContentIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/content/compose": {
      id: "/_app/content/compose"
      path: "/content/compose"
      fullPath: "/content/compose"
      preLoaderRoute: typeof AppContentComposeRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/dashboards/": {
      id: "/_app/dashboards/"
      path: "/dashboards"
      fullPath: "/dashboards/"
      preLoaderRoute: typeof AppDashboardsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/dashboards/$dashboardId": {
      id: "/_app/dashboards/$dashboardId"
      path: "/dashboards/$dashboardId"
      fullPath: "/dashboards/$dashboardId"
      preLoaderRoute: typeof AppDashboardsDashboardIdRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/people/": {
      id: "/_app/people/"
      path: "/people"
      fullPath: "/people/"
      preLoaderRoute: typeof AppPeopleIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/people/$contactId": {
      id: "/_app/people/$contactId"
      path: "/people/$contactId"
      fullPath: "/people/$contactId"
      preLoaderRoute: typeof AppPeopleContactIdRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings/": {
      id: "/_app/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/ai": {
      id: "/_app/settings/ai"
      path: "/ai"
      fullPath: "/settings/ai"
      preLoaderRoute: typeof AppSettingsAiRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/api": {
      id: "/_app/settings/api"
      path: "/api"
      fullPath: "/settings/api"
      preLoaderRoute: typeof AppSettingsApiRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/appearance": {
      id: "/_app/settings/appearance"
      path: "/appearance"
      fullPath: "/settings/appearance"
      preLoaderRoute: typeof AppSettingsAppearanceRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/billing": {
      id: "/_app/settings/billing"
      path: "/billing"
      fullPath: "/settings/billing"
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/calendar": {
      id: "/_app/settings/calendar"
      path: "/calendar"
      fullPath: "/settings/calendar"
      preLoaderRoute: typeof AppSettingsCalendarRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/channels": {
      id: "/_app/settings/channels"
      path: "/channels"
      fullPath: "/settings/channels"
      preLoaderRoute: typeof AppSettingsChannelsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/data": {
      id: "/_app/settings/data"
      path: "/data"
      fullPath: "/settings/data"
      preLoaderRoute: typeof AppSettingsDataRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/general": {
      id: "/_app/settings/general"
      path: "/general"
      fullPath: "/settings/general"
      preLoaderRoute: typeof AppSettingsGeneralRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/notifications": {
      id: "/_app/settings/notifications"
      path: "/notifications"
      fullPath: "/settings/notifications"
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/plan": {
      id: "/_app/settings/plan"
      path: "/plan"
      fullPath: "/settings/plan"
      preLoaderRoute: typeof AppSettingsPlanRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/preferences": {
      id: "/_app/settings/preferences"
      path: "/preferences"
      fullPath: "/settings/preferences"
      preLoaderRoute: typeof AppSettingsPreferencesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/profile": {
      id: "/_app/settings/profile"
      path: "/profile"
      fullPath: "/settings/profile"
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/tags": {
      id: "/_app/settings/tags"
      path: "/tags"
      fullPath: "/settings/tags"
      preLoaderRoute: typeof AppSettingsTagsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/_app/settings/team": {
      id: "/_app/settings/team"
      path: "/team"
      fullPath: "/settings/team"
      preLoaderRoute: typeof AppSettingsTeamRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    "/admin/org-plan/$orgId": {
      id: "/admin/org-plan/$orgId"
      path: "/org-plan/$orgId"
      fullPath: "/admin/org-plan/$orgId"
      preLoaderRoute: typeof AdminOrgPlanOrgIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/_app/automation/agents/": {
      id: "/_app/automation/agents/"
      path: "/automation/agents"
      fullPath: "/automation/agents/"
      preLoaderRoute: typeof AppAutomationAgentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/automation/agents/$agentId": {
      id: "/_app/automation/agents/$agentId"
      path: "/automation/agents/$agentId"
      fullPath: "/automation/agents/$agentId"
      preLoaderRoute: typeof AppAutomationAgentsAgentIdRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/automation/rules/$ruleId": {
      id: "/_app/automation/rules/$ruleId"
      path: "/automation/rules/$ruleId"
      fullPath: "/automation/rules/$ruleId"
      preLoaderRoute: typeof AppAutomationRulesRuleIdRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/content/posts/": {
      id: "/_app/content/posts/"
      path: "/content/posts"
      fullPath: "/content/posts/"
      preLoaderRoute: typeof AppContentPostsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/content/posts/$postId": {
      id: "/_app/content/posts/$postId"
      path: "/content/posts/$postId"
      fullPath: "/content/posts/$postId"
      preLoaderRoute: typeof AppContentPostsPostIdRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/dashboards/account/$accountId": {
      id: "/_app/dashboards/account/$accountId"
      path: "/dashboards/account/$accountId"
      fullPath: "/dashboards/account/$accountId"
      preLoaderRoute: typeof AppDashboardsAccountAccountIdRouteImport
      parentRoute: typeof AppRoute
    }
    "/admin/orgs_/$orgId/ai": {
      id: "/admin/orgs_/$orgId/ai"
      path: "/orgs/$orgId/ai"
      fullPath: "/admin/orgs/$orgId/ai"
      preLoaderRoute: typeof AdminOrgsOrgIdAiRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/users_/$userId/ai": {
      id: "/admin/users_/$userId/ai"
      path: "/users/$userId/ai"
      fullPath: "/admin/users/$userId/ai"
      preLoaderRoute: typeof AdminUsersUserIdAiRouteImport
      parentRoute: typeof AdminRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAiRoute: typeof AdminAiRoute
  AdminAiActivityRoute: typeof AdminAiActivityRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminCalendarRoute: typeof AdminCalendarRoute
  AdminFlowsRoute: typeof AdminFlowsRoute
  AdminOrgsRoute: typeof AdminOrgsRoute
  AdminPlanLogRoute: typeof AdminPlanLogRoute
  AdminPlansRoute: typeof AdminPlansRoute
  AdminRequestsRoute: typeof AdminRequestsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminSystemRoute: typeof AdminSystemRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminOrgPlanOrgIdRoute: typeof AdminOrgPlanOrgIdRoute
  AdminOrgsOrgIdAiRoute: typeof AdminOrgsOrgIdAiRoute
  AdminUsersUserIdAiRoute: typeof AdminUsersUserIdAiRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAiRoute: AdminAiRoute,
  AdminAiActivityRoute: AdminAiActivityRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminCalendarRoute: AdminCalendarRoute,
  AdminFlowsRoute: AdminFlowsRoute,
  AdminOrgsRoute: AdminOrgsRoute,
  AdminPlanLogRoute: AdminPlanLogRoute,
  AdminPlansRoute: AdminPlansRoute,
  AdminRequestsRoute: AdminRequestsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminSystemRoute: AdminSystemRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminOrgPlanOrgIdRoute: AdminOrgPlanOrgIdRoute,
  AdminOrgsOrgIdAiRoute: AdminOrgsOrgIdAiRoute,
  AdminUsersUserIdAiRoute: AdminUsersUserIdAiRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsAiRoute: typeof AppSettingsAiRoute
  AppSettingsApiRoute: typeof AppSettingsApiRoute
  AppSettingsAppearanceRoute: typeof AppSettingsAppearanceRoute
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsCalendarRoute: typeof AppSettingsCalendarRoute
  AppSettingsChannelsRoute: typeof AppSettingsChannelsRoute
  AppSettingsDataRoute: typeof AppSettingsDataRoute
  AppSettingsGeneralRoute: typeof AppSettingsGeneralRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsPlanRoute: typeof AppSettingsPlanRoute
  AppSettingsPreferencesRoute: typeof AppSettingsPreferencesRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsTagsRoute: typeof AppSettingsTagsRoute
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsAiRoute: AppSettingsAiRoute,
  AppSettingsApiRoute: AppSettingsApiRoute,
  AppSettingsAppearanceRoute: AppSettingsAppearanceRoute,
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsCalendarRoute: AppSettingsCalendarRoute,
  AppSettingsChannelsRoute: AppSettingsChannelsRoute,
  AppSettingsDataRoute: AppSettingsDataRoute,
  AppSettingsGeneralRoute: AppSettingsGeneralRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsPlanRoute: AppSettingsPlanRoute,
  AppSettingsPreferencesRoute: AppSettingsPreferencesRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsTagsRoute: AppSettingsTagsRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteChildren {
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppApprovalsRoute: typeof AppApprovalsRoute
  AppAssistantRoute: typeof AppAssistantRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppComposeRoute: typeof AppComposeRoute
  AppHomeRoute: typeof AppHomeRoute
  AppInboxRoute: typeof AppInboxRoute
  AppJobsRoute: typeof AppJobsRoute
  AppPostsRoute: typeof AppPostsRoute
  AppRulesRoute: typeof AppRulesRoute
  AppStudioRoute: typeof AppStudioRoute
  AppAutomationLogRoute: typeof AppAutomationLogRoute
  AppAutomationRunsRoute: typeof AppAutomationRunsRoute
  AppContactsContactIdRoute: typeof AppContactsContactIdRoute
  AppContentComposeRoute: typeof AppContentComposeRoute
  AppDashboardsDashboardIdRoute: typeof AppDashboardsDashboardIdRoute
  AppPeopleContactIdRoute: typeof AppPeopleContactIdRoute
  AppAutomationIndexRoute: typeof AppAutomationIndexRoute
  AppContactsIndexRoute: typeof AppContactsIndexRoute
  AppContentIndexRoute: typeof AppContentIndexRoute
  AppDashboardsIndexRoute: typeof AppDashboardsIndexRoute
  AppPeopleIndexRoute: typeof AppPeopleIndexRoute
  AppAutomationAgentsAgentIdRoute: typeof AppAutomationAgentsAgentIdRoute
  AppAutomationRulesRuleIdRoute: typeof AppAutomationRulesRuleIdRoute
  AppContentPostsPostIdRoute: typeof AppContentPostsPostIdRoute
  AppDashboardsAccountAccountIdRoute: typeof AppDashboardsAccountAccountIdRoute
  AppAutomationAgentsIndexRoute: typeof AppAutomationAgentsIndexRoute
  AppContentPostsIndexRoute: typeof AppContentPostsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppApprovalsRoute: AppApprovalsRoute,
  AppAssistantRoute: AppAssistantRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppComposeRoute: AppComposeRoute,
  AppHomeRoute: AppHomeRoute,
  AppInboxRoute: AppInboxRoute,
  AppJobsRoute: AppJobsRoute,
  AppPostsRoute: AppPostsRoute,
  AppRulesRoute: AppRulesRoute,
  AppStudioRoute: AppStudioRoute,
  AppAutomationLogRoute: AppAutomationLogRoute,
  AppAutomationRunsRoute: AppAutomationRunsRoute,
  AppContactsContactIdRoute: AppContactsContactIdRoute,
  AppContentComposeRoute: AppContentComposeRoute,
  AppDashboardsDashboardIdRoute: AppDashboardsDashboardIdRoute,
  AppPeopleContactIdRoute: AppPeopleContactIdRoute,
  AppAutomationIndexRoute: AppAutomationIndexRoute,
  AppContactsIndexRoute: AppContactsIndexRoute,
  AppContentIndexRoute: AppContentIndexRoute,
  AppDashboardsIndexRoute: AppDashboardsIndexRoute,
  AppPeopleIndexRoute: AppPeopleIndexRoute,
  AppAutomationAgentsAgentIdRoute: AppAutomationAgentsAgentIdRoute,
  AppAutomationRulesRuleIdRoute: AppAutomationRulesRuleIdRoute,
  AppContentPostsPostIdRoute: AppContentPostsPostIdRoute,
  AppDashboardsAccountAccountIdRoute: AppDashboardsAccountAccountIdRoute,
  AppAutomationAgentsIndexRoute: AppAutomationAgentsIndexRoute,
  AppContentPostsIndexRoute: AppContentPostsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  CreateOrgRoute: CreateOrgRoute,
  DataDeletionRoute: DataDeletionRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  SignupReceivedRoute: SignupReceivedRoute,
  SignupIndexRoute: SignupIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
